import { render, staticRenderFns } from "./TimelessTenderRegulations.vue?vue&type=template&id=4ff63d60&scoped=true"
import script from "./TimelessTenderRegulations.vue?vue&type=script&lang=js"
export * from "./TimelessTenderRegulations.vue?vue&type=script&lang=js"
import style0 from "./TimelessTenderRegulations.vue?vue&type=style&index=0&id=4ff63d60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff63d60",
  null
  
)

export default component.exports